import React from "react"
import { Box } from "rebass"
import { motion } from "framer-motion"

import HashtagBox from "./hashtag-box"

function getRandomInt(min, max) {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1)) + min
}

const getRandomCoordinates = () => {
  const newX = getRandomInt(1, 100)
  const newY = getRandomInt(1, 100)
  return { x: newX, y: newY }
}

const FloatingBox = ({ initialPos, width, height }) => {
  const [ready, setReady] = React.useState(false)
  const [pos, setPos] = React.useState(getRandomCoordinates)

  React.useEffect(() => {
    if (!ready && height > 0) {
      setReady(true)
    }
  }, [height, ready])

  const handleComplete = React.useCallback(() => {
    const newCoords = getRandomCoordinates()
    setPos(newCoords)
  }, [setPos])

  return (
    <Box css={{ position: "absolute", zIndex: 10 }}>
      {ready && (
        <motion.div
          initial={initialPos}
          animate={{
            x: `${width * (pos.x / 100) - 150}px`,
            y: `${height * (pos.y / 100) - 40}px`,
          }}
          onAnimationComplete={handleComplete}
          transition={{ duration: 70 }}
        >
          <HashtagBox />
        </motion.div>
      )}
    </Box>
  )
}

export default FloatingBox
